// states/scroll-to-table-column.state.ts
import { atom } from 'jotai';

export const scrollToTableColumnIdState = atom<string | null>(null);
